import {FACILITY_CATEGORY} from '../../CodeMaster'
import {Nullable} from '../../app/TypeHelpers'

export function getFacilityCategoryImageUrl(category: Nullable<FACILITY_CATEGORY>): string {
    const basePath: string = `/resources/images/upload`
    switch (category) {
        case FACILITY_CATEGORY.GUEST_ROOM:
            return `${basePath}/guest_room.svg`
        case FACILITY_CATEGORY.GUEST_PARKING_CARWASH:
            return `${basePath}/parking.svg`
        case FACILITY_CATEGORY.CYCLING:
            return `${basePath}/cycling.svg`
        case FACILITY_CATEGORY.OTHER:
            return `${basePath}/etc.svg`
        default:
            return `${basePath}/blank.png`
    }
}
